module.exports = __webpack_public_path__ + "static/media/create_notification_configuration_template.8efb6e4b.xlsx";